import { createTaggedErr } from "@maker/result";
import type { $ZodIssue } from "zod/v4/core";

type StatusCodes = keyof typeof statusCodes;

const statusCodes = {
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	PAYMENT_REQUIRED: 402,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	METHOD_NOT_SUPPORTED: 405,
	TIMEOUT: 408,
	CONFLICT: 409,
	PRECONDITION_FAILED: 412,
	PAYLOAD_TOO_LARGE: 413,
	UNSUPPORTED_MEDIA_TYPE: 415,
	UNPROCESSABLE_CONTENT: 422,
	TOO_MANY_REQUESTS: 429,
	CLIENT_CLOSED_REQUEST: 499,
	INTERNAL_SERVER_ERROR: 500,
	NOT_IMPLEMENTED: 501,
	BAD_GATEWAY: 502,
	SERVICE_UNAVAILABLE: 503,
	GATEWAY_TIMEOUT: 504,
} as const;

const httpErr = createTaggedErr<{
	status: number;
	payload: unknown;
	url: string;
	headers: Record<PropertyKey, string>;
}>("http", { message: "Error fetching data" });

const zodErr = createTaggedErr<{ issues: $ZodIssue[] }>("zod", {
	message: "Error parsing data",
});

export { statusCodes, httpErr, zodErr, type StatusCodes };
